import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IShelterActions, IThunkGetAvailableShelters } from '../types';

const onGetAvailableShelters: IThunkGetAvailableShelters = thunk(
  async ({ setAvailableShelters }: Actions<IShelterActions>, { clinicId }) => {
    const { items } = await api.shelters
      .getClinicShelters(clinicId, { pageNumber: 1, pageSize: 5000, filtering: 1 })
      .then(r => r.data);

    setAvailableShelters(items);
  },
);

export default onGetAvailableShelters;
